<template>
	<div class="container-md mh-100">
		<LayoutHeaderSection>
			<template #title>
				<LayoutTextSection text="Editar usuario" :breadcrumb="true" />
			</template>
		</LayoutHeaderSection>
		<main class="pt-8 vstack gap-10">
			<CommonFormWrapper submitText="Guardar" :cancelUrl="{ name: 'company.admin.user.index' }" :submitting="submitting" :errors="validationExternal" @submit="submit" v-if="!loading">
				<template #body>
					<CommonFormInputReadonly v-model="target.name" title="Nombre" />
					<CommonFormInputReadonly v-model="target.email" title="Email" />
					<CommonFormInputCheckbox v-model="target.pivot.roles" title="Roles" :options="rolesOptions" />
					<CommonFormInputCheckbox v-model="target.pivot.groups" title="Grupos asignados" :options="groupsOptions" v-if="target.pivot.roles.includes('leader')" />
					<CommonFormInputSelect v-model="target.pivot.currency" title="Moneda asignada" placeholder="En la moneda original" info="Es la moneda en la que se asignarán las comisiones. Si desea que la plataforma reparta comisiones en distintas monedas, debe especificar los tipos de cambio en la sección <b>Perfil</b> ➜ <b>Tipos de cambio</b>. De lo contrario, no se realizará ninguna conversión." :options="$env.GENERAL.currencies" v-if="target.pivot.roles.includes('seller')" />
				</template>
			</CommonFormWrapper>
		</main>
	</div>
</template>

<script>
	import { ref, reactive, computed, onBeforeMount, inject } from 'vue';
	import router from '@/router';
	import _ from 'lodash';
	import moment from 'moment';
	import useVuelidate from '@vuelidate/core';
	import { required, minLength, maxLength } from '@/helpers/i18n/validators';
	import composableForm from '@/composables/form';
	import CompanyAdminGroupRepository from '@/repositories/modules/Company/Admin/Group';
	import CompanyAdminUserRepository from '@/repositories/modules/Company/Admin/User';

	export default {
		props: {
			id: String
		},
		setup(props) {
			const { loading, submitting, validationExternal, catchError } = composableForm();
			const $env = inject('$env');
			const groups = ref([]);
			const rolesOptions = computed(() => _.mapValues($env.MODEL.User.roles, (role) => role.title));
			const groupsOptions = computed(() => _.mapValues(_.keyBy(groups.value, 'id'), 'name'));
			const target = reactive({});
			const validation = useVuelidate({}, target);

			const submit = async () => {
				if(submitting.value) return;
				validationExternal.value = [];
				if(!await validation.value.$validate()) return;

				submitting.value = true;

				await CompanyAdminUserRepository.update(props.id, target).then(() => {
					router.push({ name: 'company.admin.user.index' });
				}).catch(catchError);

				submitting.value = false;
			}

			onBeforeMount(async () => {
				try {
					const [ groupsResponse, userResponse ] = await Promise.all([
						CompanyAdminGroupRepository.list(),
						(props.id != undefined) ? CompanyAdminUserRepository.show(props.id) : null
					]);

					if(groupsResponse?.data !== undefined) {
						groups.value = groupsResponse.data;
					}

					if(userResponse?.data !== undefined) {
						Object.assign(target, userResponse.data);
						if(target.phone == null) target.phone = '-';
						if(target.permissions == null) target.permissions = [];
						if(target.pivot.groups == null) target.pivot.groups = [];
						else target.pivot.groups = _.intersection(target.pivot.groups, _.map(groups.value, (group) => String(group.id)));
					}
				}catch(e) {
					catchError(e, true);
					router.push({ name: `company.admin.user.index` });
				}finally {
					loading.value = false;
				}
			});

			return { loading, rolesOptions, groupsOptions, target, submit, submitting, validation, validationExternal };
		}
	}
</script>